export default __webpack_public_path__ + "upload-white-green-icon.svg";